"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePackageString = exports.PACKAGE_STRING_VALIDATION_ERRORS = void 0;
exports.PACKAGE_STRING_VALIDATION_ERRORS = {
    SCOPE_AND_NAME_REQUIRED: 'Package scope and name are required',
    SCOPE_FORMAT_INVALID: 'Package scope should start with "@"',
    PACKAGE_STRING_FORMAT: 'Package version should be provided after scope and name',
};
// NOTE: regular expression from https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEM_VER_REG_EXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
var validatePackageString = function (scope, name, version) {
    if (!version &&
        (scope.match(SEM_VER_REG_EXP) || name.match(SEM_VER_REG_EXP))) {
        throw new Error(exports.PACKAGE_STRING_VALIDATION_ERRORS.SCOPE_AND_NAME_REQUIRED);
    }
    if (version &&
        (scope.match(SEM_VER_REG_EXP) || name.match(SEM_VER_REG_EXP))) {
        throw new Error(exports.PACKAGE_STRING_VALIDATION_ERRORS.PACKAGE_STRING_FORMAT);
    }
    if (scope && !scope.startsWith('@')) {
        throw new Error(exports.PACKAGE_STRING_VALIDATION_ERRORS.SCOPE_FORMAT_INVALID);
    }
};
exports.validatePackageString = validatePackageString;
//# sourceMappingURL=validatePackageString.js.map